import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const CHAPTERS = [
  {
    num: "01",
    title: "Missão",
    body: "Prestar serviços com excelência nas áreas de gestão e prevenção de perdas, promovendo a sustentabilidade do negócio.",
  },
  {
    num: "02",
    title: "Visão",
    body: "Ser referência nacional em monitoramento, rastreamento e resgate de carrinhos de supermercados, proporcionando impacto positivo nas organizações.",
  },
  {
    num: "03",
    title: "Valores",
    items: [
      "Ética & Respeito",
      "Comprometimento",
      "Inclusão & Transparência",
      "Valorização das pessoas",
      "Inovação",
      "Sustentabilidade",
    ],
  },
];

export const Manifesto = () => (
  <section id="manifesto" className="relative border-y border-white/10 bg-[#162B63] py-24 sm:py-32" data-testid="manifesto-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="mb-16"
      >
        <p className="font-tech text-xs font-bold uppercase tracking-[0.25em] text-[#A3E635]">Manifesto</p>
        <h2 className="font-display mt-4 max-w-2xl text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl">
          O que nos move, em três capítulos.
        </h2>
      </motion.div>

      <div className="space-y-0">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.num}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: EASE }}
            className="group grid grid-cols-1 gap-6 border-t border-white/10 py-12 last:border-b md:grid-cols-[140px_1fr] lg:grid-cols-[200px_1fr_1fr] lg:items-start"
            data-testid={`manifesto-chapter-${c.num}`}
          >
            <span className="font-display text-6xl font-black tracking-tight text-white/10 transition-colors duration-500 group-hover:text-[#A3E635]/60 lg:text-7xl">
              {c.num}
            </span>
            <h3 className="font-display text-2xl font-extrabold tracking-tight sm:text-3xl lg:pt-2">{c.title}</h3>
            {c.body ? (
              <p className="max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg lg:pt-2">{c.body}</p>
            ) : (
              <ul className="grid max-w-xl grid-cols-1 gap-3 sm:grid-cols-2 lg:pt-1">
                {c.items.map((item) => (
                  <li key={item} className="flex items-center gap-3 text-sm text-slate-300">
                    <CheckCircle2 className="h-4 w-4 shrink-0 text-[#10B981]" />
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
